export const clampPct = (v) => Math.min(100, Math.max(0, Number(v) || 0));

/** Round money to 2 decimal places. */
export const roundMoney = (v) =>
  Math.round((Number(v) || 0) * 100) / 100;

export const lineGross = (m, unitPrice = (x) => x.price || 0) =>
  unitPrice(m) * (m.count || 0);

export const calculateListSubtotal = (lines, unitPrice = (m) => m.price || 0) =>
  lines.reduce((sum, m) => sum + lineGross(m, unitPrice), 0);

/**
 * Per-line discount breakdown for per_line scope or proportional share under order_total.
 */
export function getLineDiscountInfo(
  m,
  {
    discountScope = "per_line",
    orderHeaderKind = "percent",
    orderDiscountPercent = 0,
    orderDiscountFixed = 0,
    listSubtotal,
  },
  unitPrice = (x) => x.price || 0,
) {
  const gross = lineGross(m, unitPrice);
  const list = listSubtotal ?? calculateListSubtotal([m], unitPrice);

  if (discountScope === "per_line") {
    const pct = clampPct(m.discountPercent);
    const amount = roundMoney(gross * (pct / 100));
    const net = roundMoney(Math.max(0, gross - amount));
    return { percent: pct, amount, net, gross };
  }

  if (orderHeaderKind === "percent") {
    const pct = clampPct(orderDiscountPercent);
    const amount = roundMoney(gross * (pct / 100));
    const net = roundMoney(Math.max(0, gross - amount));
    return { percent: pct, amount, net, gross };
  }

  const fixed = Math.max(0, Number(orderDiscountFixed) || 0);
  const amount = roundMoney(list > 0 ? fixed * (gross / list) : 0);
  const net = roundMoney(Math.max(0, gross - amount));
  const percent = gross > 0 ? (amount / gross) * 100 : 0;
  return { percent, amount, net, gross };
}

export function calculateFinalTotal(
  lines,
  discountOpts,
  unitPrice = (m) => m.price || 0,
) {
  const list = calculateListSubtotal(lines, unitPrice);
  const opts = { ...discountOpts, listSubtotal: list };

  if (discountOpts.discountScope === "order_total") {
    if (discountOpts.orderHeaderKind === "percent") {
      return roundMoney(
        Math.max(
          0,
          list * (1 - clampPct(discountOpts.orderDiscountPercent) / 100),
        ),
      );
    }
    return roundMoney(
      Math.max(
        0,
        list - Math.max(0, Number(discountOpts.orderDiscountFixed) || 0),
      ),
    );
  }

  return roundMoney(
    lines.reduce(
      (sum, m) => sum + getLineDiscountInfo(m, opts, unitPrice).net,
      0,
    ),
  );
}

export const defaultDiscountState = {
  discountScope: "per_line",
  orderHeaderKind: "percent",
  orderDiscountPercent: 0,
  orderDiscountFixed: 0,
};
